













import { SPACE_TYPE } from "@/resources/constants/space";
import Loader from "@/resources/mixins/loader/loader";
import UserValidator from "@/resources/mixins/userValidator";
import { mixins } from "vue-class-component";
import { Component, Vue } from "vue-property-decorator";
import { BOT_CHAT } from "@/resources/constants/botChat";
@Component({ name: "help-bot-component" })
export default class HelpBotComponent extends mixins(
  Vue,
  Loader,
  UserValidator
) {
  get active(): boolean {
    return this.$store.getters["FloatMenuStore/getOpenHelpBot"];
  }
  set active(e: boolean) {
    this.$store.dispatch("FloatMenuStore/setOpenHelpBotAction", e);
  }
  get user() {
    return this.$store.getters["UserStore/getSpaceUser"];
  }
  get url(): string {
    if (this.user && this.isAdmin() && this.isSpaceEvent()) {
      return BOT_CHAT.EVENT_ADMIN;
    }
    if (this.user && this.isSpaceEvent()) {
      return BOT_CHAT.EVENT_USER;
    }
    if (this.user && this.isAdmin() && this.isSpaceOffice()) {
      return BOT_CHAT.OFFICE_ADMIN;
    }
    if (this.user && this.isSpaceOffice()) {
      return BOT_CHAT.OFFICE_USER;
    }
    return BOT_CHAT.INVITE_USER;
  }
  isSpaceEvent() {
    const space = this.$store.getters["SpaceStore/getSpace"];
    if (space && space.type && space.type == SPACE_TYPE.EVENT_TYPE) {
      return true;
    }
    return false;
  }
  isSpaceOffice() {
    const space = this.$store.getters["SpaceStore/getSpace"];
    if (space && space.type && space.type == SPACE_TYPE.OFFICE_TYPE) {
      return true;
    }
    return false;
  }
}
